import { createFileRoute } from "@tanstack/react-router";
import { TermlyPolicyPage } from "@/knowmeno/TermlyPolicyPage";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — KnowMeno" },
      { name: "description", content: "How KnowMeno collects, uses, and protects your health and account data — written in plain English so you know exactly what stays yours." },
      { property: "og:title", content: "Privacy Policy — KnowMeno" },
      { property: "og:description", content: "How KnowMeno collects, uses, and protects your health and account data — written in plain English so you know exactly what stays yours." },
      { property: "og:url", content: "https://www.knowmeno.com/privacy" },
    ],
    links: [{ rel: "canonical", href: "https://www.knowmeno.com/privacy" }],
  }),
  component: () => (
    <TermlyPolicyPage dataId="8749a141-3105-456f-82d5-4d201c80c6cb" title="Privacy Policy" />
  ),
});
